"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDropletAction = void 0;
const getDropletAction = ({ httpClient, }) => ({ action_id, droplet_id, }) => {
    const path = '/droplets';
    const url = `${path}/${droplet_id}/actions/${action_id}`;
    return httpClient.get(url);
};
exports.getDropletAction = getDropletAction;
//# sourceMappingURL=get-droplet-action.js.map